import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { MailchimpPopupForm } from "./mailchimp-popup-form";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  pointer-events: ${props => (props.isVisible ? "auto" : "none")};
  transition: opacity 0.3s ease-in-out;
`;

const PopupContainer = styled.div`
  background-color: #fff;
  border: 1px solid #000;
  max-width: 500px;
  width: 100%;
  position: relative;
  padding: 30px;
  box-sizing: border-box;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: auto;

  @media (max-width: 600px) {
    padding: 20px;
    max-width: 100%;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: #000;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 150ms ease;

  &:hover {
    color: #6f6d6d;
  }

  &:focus {
    outline: none;
  }
`;

const PopupTitle = styled.h2`
  margin: 0 0 16px 0;
  padding: 0 0 5px 0;
  border-bottom: 1px solid #000;
  font-size: inherit;
  line-height: inherit;
`;

const PopupFormContainer = styled.div`
  width: 100%;
`;

const SESSION_STORAGE_KEY = "mailchimp-popup-closed";

export const MailchimpPopup = () => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if popup was already closed in this session
    const wasClosed = sessionStorage.getItem(SESSION_STORAGE_KEY);

    if (!wasClosed) {
      // Render popup after 4 seconds
      const renderTimer = setTimeout(() => {
        setShouldRender(true);
        // Show popup immediately after rendering
        setTimeout(() => {
          setIsVisible(true);
        }, 10);
      }, 4000);

      return () => clearTimeout(renderTimer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Remember that popup was closed in this session
    sessionStorage.setItem(SESSION_STORAGE_KEY, "true");
    // Remove from DOM after transition
    setTimeout(() => {
      setShouldRender(false);
    }, 300);
  };

  const handleOverlayClick = e => {
    // Close if clicking on overlay (not the popup itself)
    // Stop propagation to prevent interfering with form clicks
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handlePopupClick = e => {
    // Stop propagation so clicks inside popup don't close it
    e.stopPropagation();
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <Overlay isVisible={isVisible} onClick={handleOverlayClick}>
      <PopupContainer isVisible={isVisible} onClick={handlePopupClick}>
        <CloseButton onClick={handleClose} aria-label="Close popup">
          ×
        </CloseButton>
        <PopupTitle>Gallery Mailing List</PopupTitle>
        <PopupFormContainer>
          <MailchimpPopupForm onSuccess={handleClose} />
        </PopupFormContainer>
      </PopupContainer>
    </Overlay>
  );
};
